import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Footer from '../components/Footer';

function IzmirGaleri({ siteData }) {
  const [images, setImages] = useState([]);

  // Fancybox'ı initialize et
  useEffect(() => {
    Fancybox.bind("[data-fancybox='izmir-gallery']", {
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [],
          right: ["close"],
        },
      },
      Thumbs: {
        display: true,
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, [images]);

  // Örnek fotoğraf verileri - Component mount olduğunda yükle
  useEffect(() => {
    console.log('İzmirGaleri component mount oldu');
    const exampleImages = [
      { id: 1, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 1' },
      { id: 2, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 2' },
      { id: 3, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 3' },
      { id: 4, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 4' },
      { id: 5, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 5' },
      { id: 6, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 6' },
      { id: 7, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 7' },
      { id: 8, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 8' },
      { id: 9, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 9' },
      { id: 10, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 10' },
      { id: 11, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 11' },
      { id: 12, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 12' },
      { id: 13, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 13' },
      { id: 14, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 14' },
      { id: 15, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 15' },
      { id: 16, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 16' },
      { id: 17, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 17' },
      { id: 18, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 18' },
      { id: 19, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 19' },
      { id: 20, url: '/images/proje_1.jpg', alt: 'İzmir Ağaçlandırma Projesi 20' },
    ];
    console.log('Örnek görseller yükleniyor, toplam:', exampleImages.length);
    setImages(exampleImages);
  }, []);

  // siteData yüklendiğinde API'den gelen veriyi kullan
  useEffect(() => {
    if (siteData?.izmirGallery && siteData.izmirGallery.length > 0) {
      setImages(siteData.izmirGallery);
    }
  }, [siteData]);

  console.log('İzmirGaleri render ediliyor, images:', images.length);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <Helmet>
        <title>İzmir Galeri - Ağaçlandırma Seferberliği | ALJ Türkiye</title>
        <meta 
          name="description" 
          content="İzmir ağaçlandırma projesi fotoğraf galerisi. ALJ Türkiye'nin İzmir'de gerçekleştirdiği ağaçlandırma çalışmalarını görüntüleyin." 
        />
      </Helmet>

      {/* Galeri İçerik */}
      <section className="izmir-gallery-section">
        <div className="container izmir-gallery-container">
          {/* Başlık */}
          <div className="izmir-gallery-header text-center">
            <h1>İzmir Galeri</h1>
            <p>
              ALJ Türkiye'nin İzmir'de gerçekleştirdiği ağaçlandırma projesi kapsamında dikilen fidanların ve 
              doğanın yeniden canlandırılması sürecinin fotoğrafları. Her bir fotoğraf, sürdürülebilir bir gelecek 
              için atılan adımların birer kanıtıdır.
            </p>
          </div>

          {/* Galeri Grid */}
          <div className="izmir-gallery-grid">
            {images.length > 0 ? (
              <div className="izmir-gallery-row">
                {images.map((image, index) => {
                  const imageUrl = image.url || image.cover || image;
                  const imageAlt = image.alt || `İzmir Galeri Fotoğraf ${index + 1}`;
                  return (
                    <div 
                      key={image.id || index} 
                      className="gallery-item"
                    >
                      <img
                        src={imageUrl}
                        alt={imageAlt}
                        data-fancybox="izmir-gallery"
                        data-src={imageUrl}
                        data-caption={imageAlt}
                        loading="lazy"
                        onError={(e) => {
                          console.error('Görsel yüklenemedi:', imageUrl);
                          e.target.style.display = 'none';
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="izmir-gallery-loading text-center">
                <p>Fotoğraflar yükleniyor... (Toplam: {images.length})</p>
              </div>
            )}
          </div>

          {/* Fotoğraf Sayısı Bilgisi */}
          {images.length > 0 && (
            <div className="izmir-gallery-count text-center">
              <p>Toplam {images.length} fotoğraf</p>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <Footer siteData={siteData} />
    </div>
  );
}

export default IzmirGaleri;

